import { http, HttpResponse } from "msw";

import { type SavedFilter } from "@vega-api/generated/types/savedFilter";
import { type SavedFilterRequest } from "@vega-api/generated/types/savedFilterRequest";
import { type UpdateSavedFilterRequest } from "@vega-api/generated/types/updateSavedFilterRequest";

const HOME_LAYOUT_TABLE_CODE_PREFIX = "gp-home.layout";
const HOME_LAYOUT_ROW_ID = "11111111-2222-3333-4444-666666666666";
const HOME_LAYOUT_STORAGE_KEY = "msw-demo.gp-home.layout";

const readHomeLayoutRow = (): SavedFilter | undefined => {
  const stored = sessionStorage.getItem(HOME_LAYOUT_STORAGE_KEY);

  return stored === null ? undefined : (JSON.parse(stored) as SavedFilter);
};

const writeHomeLayoutRow = (row: SavedFilter): SavedFilter => {
  sessionStorage.setItem(HOME_LAYOUT_STORAGE_KEY, JSON.stringify(row));

  return row;
};

export const homeLayoutDemoHandlers = [
  http.get(
    "*/api/authentication/v1/filters/by-table-code/:tableCode",
    ({ params }) => {
      if (!String(params.tableCode).startsWith(HOME_LAYOUT_TABLE_CODE_PREFIX)) {
        return;
      }

      const row = readHomeLayoutRow();

      return HttpResponse.json({ data: row ? [row] : [] });
    },
  ),
  http.post("*/api/authentication/v1/filters", async ({ request }) => {
    const body = (await request.clone().json()) as SavedFilterRequest;

    if (!body.tableCode.startsWith(HOME_LAYOUT_TABLE_CODE_PREFIX)) {
      return;
    }

    const row = writeHomeLayoutRow({
      id: HOME_LAYOUT_ROW_ID,
      filterName: body.filterName,
      filterConfig: body.filterConfig,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });

    return HttpResponse.json({ data: row });
  }),
  http.put(
    "*/api/authentication/v1/filters/:filterId",
    async ({ params, request }) => {
      if (params.filterId !== HOME_LAYOUT_ROW_ID) {
        return;
      }

      const body = (await request.clone().json()) as UpdateSavedFilterRequest;

      const row = writeHomeLayoutRow({
        ...readHomeLayoutRow(),
        filterName: body.filterName,
        filterConfig: body.filterConfig,
        updatedAt: new Date().toISOString(),
      });

      return HttpResponse.json({ data: row });
    },
  ),
];
